module.exports = __webpack_public_path__ + "img/1.506b1383.jpg";